import { constructs } from "../api/contructs";
import { createSyncedApiHook } from "../api/createSyncedApiHook";
import { createUseItemHook, createUseItemsHook } from "./createUseItemsHook";

const construct = constructs.image;

export const useImage = createUseItemHook(construct);
export const useImages = createUseItemsHook(construct);
export const useImagesApi = createSyncedApiHook(construct);
